import { EventEmitter, inject, Injectable } from "@angular/core";
 import { StorageService } from "./storage.service";
import { AppContext } from "./app-context.service";

@Injectable({
  providedIn: "root",
})
export class ApiConfig {
  private appContext = inject(AppContext);
  public portalApiUrl = "http://localhost:8801";
  public posApiUrl = "http://localhost:8802";

  public posApiPort = 4202;

  public posApiUrlChanged: EventEmitter<String> = new EventEmitter<String>();

  constructor(private storage: StorageService) {
    if (
      location.hostname === "localhost" ||
      location.hostname === "127.0.0.1"
    ) {
      this.portalApiUrl = "http://localhost:8801";
        this.posApiUrl = `http://localhost:${this.posApiPort}`;
      // for localhost set local 192.168.0.198 
    } else if (location.hostname === "192.168.170.146") {
        //remote wifi debug

         this.portalApiUrl = "http://192.168.170.146:8801";
        //this.portalApiUrl = "https://uatngcentrala.ngretail.cz";

    } else if (location.hostname === "192.168.20.51") {
      //remote wifi debug home
      this.portalApiUrl = "http://192.168.20.51:8801";
    } else if (location.hostname === "10.0.0.180") {
      //remote wifi debug home
      this.portalApiUrl = "http://10.0.0.180:8801";
    } else if (location.hostname == "192.168.200.11")
      this.portalApiUrl = "http://192.168.200.11:8801";
    else {
      this.portalApiUrl = "";
    }
    if (this.storage.SelectedPos) {
      this.updatePosIPAddress();
    }
  }

  public updatePosIPAddress() {
    this.posApiUrl = `http://${this.storage.SelectedPos.IpAddress}:${this.posApiPort}`;

    // For debug
    //this.posApiUrl = `http://localhost:8801`;

    // For server
    if (this.appContext.posAppConfig?.isWebServer) {
      this.posApiUrl = this.appContext.posAppConfig?.portalApiAddress;
    }

    this.posApiUrlChanged.emit(this.posApiUrl);
  }
}
